import React from "react";
import Accordion from "../../../shared/Accordion";
import trash from "../../../../assets/img/admin/trash.svg";
import edit from "../../../../assets/img/admin/edit-2-white.svg";
const FaqAccordion = ({info}) => {
  console.log(info)
  return (
    <div>
    {info.map(i=> <Accordion
        title={i.title}
        text={i.description}
        extraIcon={<div className='flex gap-[12px] items-center'>
            <button>
                <img src={trash}/>
            </button>
            <button className="center w-[36px] h-[36px] rounded-[8px] bg-[#00A6A6]">
                <img src={edit} />
            </button>
        </div>}
      />)  }
 
    </div>
  );
};

export default FaqAccordion;
